import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ProjectState from './context/projects/ProjectState';
import Navbar from './components/layout/Navbar';
import Home from './components/pages/Home';
import About from './components/pages/About';
import Project from './components/pages/Project';
import Projects from './components/pages/Projects';
import Contact from './components/pages/Contact';
import NotFound from './components/error/NotFound';
import './App.css';
import ScrollRestoration from "./scrollrestore/ScrollRestoration";
import ContactState from "./context/contact/ContactState";

function App() {
  return (
    <ProjectState>
      <ContactState>
        <div className="max-w-screen-2xl">
          <Router>
            <Navbar/>
            <ScrollRestoration />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/about" component={About} />
              <Route exact path="/projects" component={Projects} />
              <Route exact path="/project/:name" component={Project} />
              <Route exact path="/contact" component={Contact} />
              <Route path="*" component={NotFound} />
            </Switch>
          </Router>
        </div>
      </ContactState>
    </ProjectState>
  );
}

export default App;
